<template>
    <v-card :style="`background-color: ${this.color}`" :class="color" d-flex>
        <v-card-text>
            <v-flex d-flex>
                <v-layout column justify-center>
                    <slot name="icon">
                        <v-flex px-2 py-2 class="sdc-icon">
                            <i :class="`${icon} `" :style="`color: ${iconColor};`"></i>
                        </v-flex>
                    </slot>
                    <v-flex class="sdc-number">
                        <slot name="number" >
                                                                                        
                        </slot>
                    </v-flex>
                    <v-flex class="sdc-title">
                        <slot name="title"></slot>
                    </v-flex>
                </v-layout>
            </v-flex>        
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    props:{
        icon: {
            required: true
        },
        iconColor: {
            default: '#999'
        },
        color: {
            default: 'white'
        }
    }
}
</script>
<style >
    .sdc-icon{
        font-size: 30px;  
        display: flex;
        justify-content: center;      
    }



    .sdc-number{
        font-weight: 700;
        font-size: 1.2vw;
        display: flex;
        justify-content: center;  
        color: rgba(0,0,0,0.76);
    }

    .sdc-title{
        font-weight: 400;
        font-size: 0.8vw;
        text-transform: uppercase;
        display: flex;
        justify-content: center;  
        color: rgba(200,200,200,0.66);
    }
</style>